import { useEffect } from "react";

import { useRouter } from "next/router";

import { gtagEvent } from "@/common/services/analytics/providers/google-analytics.provider";
import {
  EXTENSION_INJECTION_EVENT,
  scanForInjectedElements,
  shouldReport,
  toEventParams,
} from "@/features/extension-injection/detectInjectedElements";

/* Overlays like price-compare panels land a few seconds after load, once the
   extension has read the product title. One scan per page, after they settle. */
const SCAN_DELAY_MS = 12_000;

/**
 * Pushes at most one `extension_injection` event per page view when foreign
 * DOM is present. Measurement only; see detectInjectedElements.ts.
 */
export const useExtensionInjectionDetection = () => {
  const { asPath } = useRouter();

  useEffect(() => {
    const timer = window.setTimeout(() => {
      try {
        const scan = scanForInjectedElements(document);

        if (shouldReport(scan)) {
          gtagEvent(EXTENSION_INJECTION_EVENT, toEventParams(scan));
        }
      } catch {
        /* Never let measurement break the page. */
      }
    }, SCAN_DELAY_MS);

    return () => window.clearTimeout(timer);
  }, [asPath]);
};
